import type { BreakdownTimeseriesDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert BreakdownTimeseriesDataSet to sheet format
 * Used for line charts and stacked bar charts broken down over time
 */
export const convertBreakdownTimeseriesDataToSheet: DataConverter<
  BreakdownTimeseriesDataSet
> = ({ data, secondaryDimension }): SheetData[] => {
  const formattedSecondaryDimension = formatColumnName(secondaryDimension);

  const segments = Array.from(new Set(data.data.map((series) => series.dim)));

  const dates = Array.from(
    new Set(
      data.data.flatMap((series) =>
        series.breakdown.map((point) => point.date.split('T')[0] ?? '')
      )
    )
  ).sort();

  const pointsBySegment = new Map(
    data.data.map((series) => [
      series.dim,
      new Map(
        series.breakdown.map((point) => [point.date.split('T')[0] ?? '', point])
      ),
    ])
  );

  const headerRow1: SheetData = { Date: formattedSecondaryDimension };
  const headerRow2: SheetData = { Date: 'Date' };

  segments.forEach((segment) => {
    const formattedSegment = formatColumnName(segment);
    headerRow1[`${formattedSegment} Count`] = formattedSegment;
    headerRow1[`${formattedSegment} Share`] = '';
    headerRow2[`${formattedSegment} Count`] = 'Count';
    headerRow2[`${formattedSegment} Share`] = 'Share';
  });

  const dataRows = dates.map((date) => {
    const row: SheetData = { Date: date };

    segments.forEach((segment) => {
      const point = pointsBySegment.get(segment)?.get(date);
      const formattedSegment = formatColumnName(segment);
      row[`${formattedSegment} Count`] = point?.value ?? 0;
      row[`${formattedSegment} Share`] = point?.share ?? 0;
    });

    return row;
  });

  return [headerRow1, headerRow2, ...dataRows];
};
